export const locale = {
    lang: 'en',
    data: {
        MODAL_CREATE_RATING: {
            TITLE: 'Rate the order',
            SUB_TITLE: 'Help us improve our services by rating your order.',
            COMMENTS: 'Comment and Suggestion',
            MODAL: {
                BUTTONS: {
                    CANCEL: 'Cancel',
                    SAVE: 'Save'
                }
            }
        },
    },
};
